import {BaseModel} from "../base";

class QueuerModel extends BaseModel {

    /**
     * @description
     * override superclass method, define the Queuer Object
     *
     * @returns {object} The Queuer Object
     */
    updateModel(data) {
        if (data) {
            this._data = data;

            for (const property in data) {
                const value = data[property];
                if (typeof(value) !== 'function') {
                    this[property] = value;
                }
            }
        }
    }

}

export {
    QueuerModel
}